module.exports = __webpack_public_path__ + "static/img/toner-01-01.9c4099d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/toner-01-01.jpg
// module id = 294
// module chunks = 1